// TODO spurning með breytunöfn upp á fallbeygingar?
// https://github.com/watson-developer-cloud/assistant-web-chat/blob/main/languages/en.json
export const watsonIS = {
	errors_communicating: 'Villa kom upp í samskiptum við Njál.',
	errors_imageSource: 'Mynd er ekki til.',
	errors_singleMessage: 'Það er villa við skilaboðin sem þú sendir nýlega, en ekki hika við að spyrja mig um annað.',
	errors_ariaMessageRetrying: 'Við eigum í vandræðum með að senda skilaboðin þín en erum enn að reyna',
	errors_ariaMessageFailed: 'Skilaboðin þín voru ekki send',
	errors_noAgentsAvailable: 'Enginn þjónustufulltrúi við.',
	errors_connectingToAgent: 'Fyrirgefðu. Eitthvað fór úrskeiðis og ég get ekki tengt þig við þjónustufulltrúa.',
	errors_busy:
		'Fyrirgefðu, en ég get ekki hjálpað þér núna. Ég er að svara spurningum frá fullt af fólki um þessar mundir. Vinsamlegast reyndu aftur síðar.',
	errors_agentAppSessionExpired: 'Fyrirgefðu, en aðgangur að samtalssögunni er útrunninn.',
	input_ariaLabel: 'Skilaboð til að senda',
	input_placeholder: 'Skrifaðu eitthvað ...',
	input_buttonLabel: 'Smelltu til að senda skilaboð',
	window_title: 'Spjallgluggi',
	window_ariaChatRegion: 'Spjallsvæði',
	window_ariaChatRegionNamespace: 'Spjallsvæði "{namespace}"',
	window_ariaWindowOpened: 'Spjallglugginn hefur verið opnaður',
	window_ariaWindowClosed: 'Spjallglugginn hefur verið lokaður',
	window_ariaWindowLoading: 'Spjallið er að hlaðast.',
	launcher_isOpen: 'Lokaðu spjallglugganum',
	launcher_isClosed: 'Opnaðu spjallgluggann',
	messages_youSaid: 'Þú sagðir',
	messages_botSaid: '{botName} sagði',
	messages_agentSaid: 'Þjónustufulltrúinn sagði',
	messages_searchResults: 'Leitarniðurstöður',
	messages_searchResultsLink: 'Opnaðu þessa leitarniðurstöðu í nýjum glugga',
	messages_botIsTyping: '{botName} er að skrifa',
	messages_agentIsTyping: 'Þjónustufulltrúinn er að skrifa',
	messages_scrollHandle: 'Spjallferill hefst',
	messages_scrollHandleDetailed:
		'Spjallferill hefst. Virkjaðu til að fókusera fyrstu skilaboðin og notaðu síðan örina, heimilistakkana og lokatakkana til að fara á milli skilaboða. Ýttu á Escape til að hætta.',
	messages_scrollHandleEnd: 'Spjallferli lýkur',
	messages_scrollHandleEndDetailed:
		'Spjallferli lýkur. Virkjaðu til að fókusera síðustu skilaboðin og notaðu síðan örina, heim og lokatakkana til að fara á milli skilaboða. Ýttu á Escape til að hætta.',
	buttons_cancel: 'Hætta við',
	options_select: 'Veldu valkost',
	options_ariaOptionsDisabled: 'Þessir valkostir eru óvirkir og ekki er hægt að velja þá',
	header_previewLinkTitle: 'Forskoðun aðstoðarmanns',
	header_ariaBotAvatar: '{botName} avatar mynd',
	homeScreen_conversationStarterLabel: 'Algeng mál',
	homeScreen_ariaQuickStartListButton: 'Flýtileiðsvalmynd',
	homeScreen_ariaQuickStartListOpened: 'Flýtileiðsvalmyndin hefur verið opnuð.',
	homeScreen_ariaQuickStartListClosed: 'Flýtimyndavalmyndinni hefur verið lokað.',
	default_agent_availableMessage:
		'Biðjið um þjónustufulltrúa og ég læt ykkur vita þegar þeir eru tilbúnir. Biðtími þinn getur verið breytilegur eftir framboði.',
	default_agent_unavailableMessage: 'Því miður er enginn þjónustufulltrúi laus núna.',
	agent_reason_error:
		'Hmmm ... ég er í smá erfiðleikum. Ég þarf mannlegan þjónustufulltrúi til að halda samtalinu handvirkt.',
	agent_mockTitle: 'Tengstu við þjónustufulltrúa',
	agent_mockDescription:
		'Tenging við svörun þjónustufulltrúa barst. Í þróun, myndir þú skrifa kóða til að takast á við þessa tengingu.',
	agent_mockMessageLabel: 'Þessi skilaboð verða send til þjónustufulltrúa:',
	agent_chatTitle: 'Þjónustuver',
	agent_startChat: 'Tala við þjónustufulltrúa',
	agent_chatRequested: 'Beðið eftir þjónustufulltrúa...',
	agent_connecting: 'Beðið eftir þjónustufulltrúa...',
	agent_agentNoNameTitle: 'Þjónustufulltrúi',
	agent_agentJoinedName: '{personName} tekur þátt í samtali',
	agent_agentJoinedNoName: 'Þjónustufulltrúi tekur þátt í samtalinu',
	agent_youConnectedWarning: 'Ef þú yfirgefur núverandi síðu verður þú að biðja um nýjan þjónustufulltrúa',
	agent_connectingMinutes:
		'Beðið eftir þjónustufulltrúa... Núverandi biðtími er <b>{time, number} {time, plural, one {minute} other {minutes}}</b>.',
	agent_connectingQueue: 'Beðið eftir þjónustufulltrúa... Þú ert númer <b>{position, number}</b> í röðinni.',
	agent_ariaOpenedAgentView: 'Spjallið við þjónustufulltrúa. Smelltu á hnappinn til að fara aftur til Njáls.',
	agent_ariaOpenedBotView: 'Spjallið við Njál. Smelltu á hnappinn til að fara aftur til þjónustufulltrúa.',
	agent_ariaConnectingCancel: 'Smelltu til að hætta við að bíða eftir þjónustufulltrúa',
	agent_ariaAgentAvatar: 'Þjónustufulltrúa avatar mynd',
	agent_ariaAgentNewMessage:
		'Þú hefur fengið ný skilaboð frá þjónustufulltrúa. Smelltu á skilaboðahnappinn til að opna skilaboð frá þjónustufulltrúa. Skilaboðin eru: {messageText}',
	agent_ariaToggleViewBot: 'Skoðaðu skilaboð með þjónustufulltrúa',
	agent_ariaLastMessageButton:
		'Smelltu til að skoða skilaboð frá þjónustufulltrúa. Síðustu skilaboðin voru: {messageText}',
	agent_ariaToggleViewAgent: 'Skilist til Njáls',
	agent_ariaAgentConnected: 'Þessi þjónustufulltrúi er tengdur',
	agent_ariaAgentNotConnected: 'Þessi þjónustufulltrúi er ekki tengdur',
	agent_youEndedChat: 'Þú hefur lokið samtalinu',
	agent_disconnected:
		'Eitthvað fór úrskeiðis og tenging þín við þjónustuborðið rofnaði. Athugaðu internettenginguna og reyndu aftur að tengjast þjónustufulltrúa.',
	agent_reconnected: 'Þjónustufulltrúinn hefur tengst aftur',
	agent_agentLeftChat: '{personName} yfirgaf samtalið',
	agent_agentLeftChatNoName: 'Þjónustufulltrúinn yfirgaf samtalið',
	agent_agentEndedChat: '{personName} lauk samtalinu',
	agent_agentEndedChatNoName: 'Þjónustufulltrúi lauk samtalinu',
	agent_transferring: 'Það er verið að flytja þig til {personName}',
	agent_transferringNoName: 'Það er verið að flytja þig til þjónustufulltrúa',
	agent_endChat: 'Ljúka samtali',
	agent_confirmEndChat: 'Ertu viss um að þú viljir ljúka samtali með þjónustufulltrúa?',
	agent_confirmEndChatNo: 'Nei',
	agent_confirmEndChatYes: 'Já',
	icon_ariaUnreadMessages:
		'Það {count, plural, one {er} other {eru}} {count, number} ólesin {count, plural, one {skilaboð} other {skilaboð}}',
	showMore: 'Sjá meira',
	suggestions_title: 'Uppástungur',
	suggestions_sectionTitleAlternateResponses: 'Sendu eitt af þessum skilaboðum',
	suggestions_sectionTitleSearch: 'Skoða skyld efni',
	suggestions_sectionTitleContact: 'Fáðu aðstoð á annan hátt',
	suggestions_sectionTitleStarters: 'Fólk hefur líka áhuga á',
	suggestions_noSearchResults: 'Ég fann ekkert til að deila með þér sem tengist núverandi samtali.',
	suggestions_connectToAgent: 'Tengjast þjónustufulltrúa',
	suggestions_ariaButtonToClose: 'Smelltu til að loka tillögum.',
	suggestions_ariaMessageButtons: 'Tillögu hnappur',
	suggestions_ariaButtonToOpen: 'Tillögu hnappur. Smelltu til að opna tillögur.',
	suggestions_ariaPanelButtonToggle: 'Smelltu til að fá fleiri eða færri tillögum.',
	suggestions_ariaAnnounceButtonShow: 'Smelltu á tillöguhnappinn til að skoða tillögur.',
	suggestions_ariaAnnounceListOpen: 'Það hefur verið opnað fyrir tillögur. Ýttu á Escape til að loka.',
	suggestions_ariaAnnounceListClosed: 'Tillögum hefur verið lokað.',
	suggestions_ariaAnnounceListExpanded: 'Tillögum hefur verið fjölgað.',
	suggestions_ariaAnnounceListCollapsed: 'Tillögur hafa hrunið.',
	suggestions_searchBookmarkHeader:
		'Gott að þú hefur fundið tengt efni. Ég geymi þetta fyrir þig hér í samtalinu okkar.',
	suggestions_searchBookmarkFooter: 'Get ég hjálpað þér með eitthvað annað?',
	showMoreResults: 'Sjá meira',
	disclaimer_title: 'Fyrirvari',
	disclaimer_accept: 'Ég samþykki',
	disclaimer_decline: 'Ég samþykki ekki',
	sessionHistory_expired:
		'Spjallstund óvirk. Sendu hvaða skilaboð sem er til að halda áfram. Ef þú endurnýjar síðuna núna þarftu að hefja nýtt samtal.',
	branding_headline: 'Byggt með <b>Pósturinn®</b>',
	branding_description:
		'Fjarlægðu gremju yfir löngum biðtíma, leiðinlegum leitum og óhagkvæmum spjallþráðum með Njál. Sparaðu peninga og tíma með því að veita viðskiptavinum þínum skjót og nákvæm svör hvar sem þeir þurfa þess.',
	branding_sign_up: 'Skráðu þig í dag.',
	general_ariaCloseInformationOverlay: 'Loka upplýsingaskjá.',
	general_ariaAnnounceOpenedInformationOverlay: 'Upplýsingaspjald hefur verið opnað.',
	general_ariaAnnounceClosedInformationOverlay: 'Upplýsingaspjald hefur verið lokað.',
	general_ariaAnnounceEscapeOverlay: 'Ýttu á Escape eða smelltu á close hnappinn til að loka.',
	branding_ariaInformationButton: 'Frekari upplýsingar um Njál.',
};
